/* tslint:disable:max-line-length */

import { CalsoftNavigationItem } from 'src/app/global/components/navigation/navigation.types';

export const defaultNavigation: CalsoftNavigationItem[] = [
  
];
export const compactNavigation: CalsoftNavigationItem[] = [
   
];
export const horizontalNavigation: CalsoftNavigationItem[] = [
    
];

export const futuristicNavigation: CalsoftNavigationItem[] = [
    
];

